import { useI18n } from "../lib/i18n";
import { nutritionNumber } from "../lib/playerSchedulePresentation";

export default function PlayerNutritionSummary({ nutrition, compact = false }) {
  const { t } = useI18n();
  const fields = compact ? [["kcal", "kcal"], ["protein", "g Protein"]]
    : [["kcal", "kcal"], ["protein", "g", "P"], ["carbohydrates", "g", "KH"], ["fat", "g", "F"]];
  if (!fields.some(([key]) => nutritionNumber(nutrition?.[key]) !== null)) {
    return <span data-testid="nutrition-pending" style={{ color: "var(--pc-muted)" }}>{t("nutritionNotAssessed")}</span>;
  }
  return <span data-testid="nutrition-values">{fields.map(([key, unit, prefix]) => `${prefix ? `${prefix} ` : ""}${nutritionNumber(nutrition?.[key]) ?? "—"} ${unit}`).join(" · ")}</span>;
}
